import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

export type BadgeTone = 'navy' | 'cyan' | 'green' | 'amber' | 'red' | 'gray' | 'white' | 'violet'

const tones: Record<BadgeTone, string> = {
    navy: 'bg-navy-900 text-white',
    cyan: 'bg-cyan-50 text-cyan-800 ring-1 ring-inset ring-cyan-200',
    green: 'bg-emerald-50 text-emerald-700 ring-1 ring-inset ring-emerald-200',
    amber: 'bg-amber-50 text-amber-800 ring-1 ring-inset ring-amber-200',
    red: 'bg-red-50 text-red-700 ring-1 ring-inset ring-red-200',
    gray: 'bg-navy-50 text-navy-700 ring-1 ring-inset ring-navy-100',
    white: 'bg-white/90 text-navy-900 shadow-sm backdrop-blur',
    violet: 'bg-violet-50 text-violet-700 ring-1 ring-inset ring-violet-200'
}

interface BadgeProps {
    tone?: BadgeTone
    className?: string
    children: ReactNode
}

export const Badge: FC<BadgeProps> = ({ tone = 'gray', className, children }) => {
    return (
        <span className={cn('inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-xs font-semibold leading-none whitespace-nowrap', tones[tone], className)}>
            {children}
        </span>
    )
}
